module.exports = __webpack_public_path__ + "static/media/icon12.872e1e59.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon12.png
// module id = 741
// module chunks = 0 1